import { useLocation, useNavigate } from 'react-router-dom';
import { Menu } from 'antd';
import { MenuItem, items } from '@/configs/routes';
import { MenuProps } from 'antd/lib';

const generateMenu = (items: MenuItem[]): MenuProps["items"] => {
    return items.filter(x => x.label).map((item) => {
        const itemChildren = item.children?.filter(x => x.label)
        if (itemChildren?.length) {
            return {
                key: item.key,
                icon: item.icon,
                label: item.label,
                children: generateMenu(itemChildren),
            };
        }
        return {
            key: item.key,
            icon: item.icon,
            label: item.label,
        };
    });
};

const Navbar = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const onClick = (event: any) => {
        const { key } = event

        const findPath = (menuList: MenuItem[]): MenuItem | undefined => {
            for (const item of menuList) {
                if (item.key === key) return item;
                if (item.children) {
                    const childPath = findPath(item.children);
                    if (childPath) return childPath;
                }
            }
            return undefined;
        };

        const item = findPath(items);

        if (item?.path) {
            navigate(item.path);
        }
    }

    const allItems = generateMenu(items)

    return (
        <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={allItems} onClick={onClick}
            style={{ flex: 1, minWidth: 0 }}
            rootClassName='app-nav-top'
        />
    );
};

export default Navbar;
